import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useUpdateContact from '../../../../hooks/dashboard/trip-log/useUpdateContact';
import {
  TripLogUpdateContactDataType,
  TripLogUpdateContactInitialValues,
  TripLogUpdateContactSchema,
} from '../../../../models/dashboard/trip-log/trip-log-update-contact';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import { TableContext } from '../../../Table/TableContext';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface UpdateContactModalProps {
  data: any;
}

const UpdateContactModal: React.FC<UpdateContactModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const { updateContact, loading } = useUpdateContact();

  const onSubmit = (value: TripLogUpdateContactDataType) => {
    updateContact(value, data?.id, data?.email, () => {
      modalContext?.setShowModal(!modalContext?.showModal);
      tableContext?.setRefreshTable(!tableContext.refreshTable);
    });
  };

  return (
    <Container>
      <ModalContainer
        label='Update Contact'
        // showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <FormComponent
          initialValues={TripLogUpdateContactInitialValues}
          schema={TripLogUpdateContactSchema}
          onSubmit={onSubmit}
          className={'small-gap'}
        >
          <TextInputField
            label='Contact Info'
            name='contactInfo'
            id='contactInfo'
            type='text'
            placeholder='Enter contact information'
          />

          <ButtonArea>
            <FormSubmitButton
              className='clear fill'
              btnType='button'
              onClick={() => modalContext?.setShowModal(false)}
            >
              Cancel
            </FormSubmitButton>

            <FormSubmitButton loading={loading} className='fill'>
              Save
            </FormSubmitButton>
          </ButtonArea>
        </FormComponent>
      </ModalContainer>
    </Container>
  );
};

export default UpdateContactModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 16px;
`;
